import React, { useEffect, useMemo, useRef, useState } from "react"
import { useHistory, useLocation } from "react-router"
import { useGlobalFilter, useSortBy, useTable } from "react-table"
import { COLUMNS } from "./ServiceCenterColumns"
// import '../../CenterAdmin/ManageStaff/ManageStaff.scss';
import "./Service.scss"
import { Button } from "@mui/material"
import { GlobalFilter } from "components/Table/GlobalFilter"
import { deleteConsultantServiceDetail, getCenterDetails, getServicesBasedOnCenterId } from "core/services/api"
import { useSelector } from "react-redux"
import Select from "react-select"
import Toast from "components/Toast"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import { MocUserRole } from "core/services/models/Enums"

export const ServiceForCenter = () => {
  const columns = useMemo(() => COLUMNS, [])
  const location = useLocation()
  const [data, setData] = useState([])
  const [displayToast, toggleDisplayToast] = useState<any>()
  const history = useHistory()
  const componentRef = useRef()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [centerDetail, setCenterDetail] = useState<any>()
  // const [centerId, setCenterId] = useState<any>(userDetail?.currentCenter?.centerId)
  const [centerId, setCenterId] = useState<any>(location?.state?.previousCenterId);
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly)
  // const [centerName, setCenterName] = useState<any>(userCenterName);
  const [centerName, setCenterName] = useState<any>(location?.state?.previousCenterName);
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })

  const element = document.getElementById("service-wrapper")
  useEffect(() => {
    console.log("inside scroll view");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }, [element])


  useEffect(() => {
    //setRole(userDetail?.currentRole);
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })
  }, [centerId])



  const handleDelete = (path: any) => {
    deleteConsultantServiceDetail(`${path}/center/${userRole === MocUserRole.CENTER_ADMIN ? userDetail?.currentCenter?.centerId : centerId}`)
      // @ts-ignore
      // @ts-ignore
      .then((res) => {
        toggleDisplayToast({
          // @ts-ignore
          text: `This Service has been deleted successfully`,
          type: "success",
        })
        getAdminServices()
      })
      .catch((err) => {
        console.log("err", err);
        toggleDisplayToast({
          // @ts-ignore
          text: `Error in deleting this service!`,
          type: "error",
        })
      })
  }

  useEffect(() => {
    getAdminServices()
  }, [centerId])



  function getAdminServices() {
    if (userRole == "CENTER_ADMIN") {
      getServicesBasedOnCenterId(userDetail?.currentCenter?.centerId)
        .then((res) => {
          console.log(res, "res from Data");
          setData(res)
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
    else {
      if (centerId) {
        getServicesBasedOnCenterId(centerId)
          .then((res) => {
            console.log(res, "res from Data");
            setData(res)
          })
          .catch((err) => {
            console.log("err", err)
          })
      }
    }

  }


  const redirectTo = (path: any, origin: any) => {
    console.log(origin)

    if (origin == "copy") {
      history.push({
        pathname: "/copyServices",
        state: { idValue: path, origin: origin },
      })
    }
    if (origin == "add") {
      history.push({
        pathname: "/Services",
        state: { idValue: path, type: 'Center', functionType: 'add', centerId: userDetail?.currentCenter?.centerId, centerName: userDetail?.currentCenter?.centerName },
      })
    }

    if (origin == "edit") {
      if (userRole == "CENTER_ADMIN") {
        history.push({
          pathname: "/Services",
          state: {
            idValue: path, type: 'Center', functionType: 'edit', centerId: userDetail?.currentCenter?.centerId, centerName: userDetail?.currentCenter?.centerName
          },
        })
      }
      else {
        history.push({
          pathname: "/Services",
          state: {
            idValue: path, type: 'Center', functionType: 'edit', centerId: centerId, centerName: centerName
          },
        })
      }
    }

  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )

  const { globalFilter } = state
  useEffect(() => {
    // Load the stored filter value from local storage
    const storedFilter = localStorage.getItem('globalFilterCenter');
    console.log(storedFilter, "stored Filter")
    if (storedFilter) {
      setGlobalFilter(storedFilter); // Apply the stored filter to the table
    }
  }, [setGlobalFilter, data]);



  return (
    <div className="services-wrapper-admin" id="service-wrapper">
      <div className="manage-patients-container">
        <div className="manage-patients-container">
          <div className="row add-new">
            <div className="filter-services">
              {userRole === "CENTER_ADMIN" ? <>
                <div style={{ marginLeft: '15px' }}>
                  <label className="filter-label-center">Location &nbsp;{userDetail?.currentCenter?.centerName} </label>
                </div>
              </> : <>
                <div>
                  <label className="filter-label">Filter By Location</label>
                  <div id="centerService" className="custom-react-select">
                    <Select
                      className=""
                      name="center"
                      defaultValue={{
                        label: "",
                        value: ""
                      }}
                      value={{
                        label: centerName,
                        value: centerId
                      }}
                      styles={customSelectStyles()}
                      options={dropdownCenters}
                      onChange={(evnt: any) => {
                        setCenterId(evnt?.value);
                        setCenterName(evnt?.label);
                        //setData({ ...data, securityDepositMode: evnt?.value })
                      }}
                    />
                  </div>
                </div>
              </>}

              {/* {role === 'SYSTEM_ADMIN' ? */}

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Button
                  id="add-button"
                  className={`button-container ${readOnly ? "read-only-button" : ""}`}
                  disabled={readOnly}
                  onClick={() => redirectTo("", "add")}
                >
                  Add New Center Services
                </Button>
                <Button
                  id="copy-button"
                  className={`button-container ${readOnly ? "read-only-button" : ""}`}
                  disabled={readOnly}
                  onClick={() => redirectTo("", "copy")}
                >
                  Copy Services
                </Button>
              </div>
            </div>
            <div className="search-container">
              <div>
                <GlobalFilter
                  filter={globalFilter}
                  setFilter={setGlobalFilter}
                />
              </div>
              <div>
              </div>
            </div>
            <div>
              <table
                {...getTableProps()}
                // @ts-ignore
                ref={componentRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "40px",
                            }}
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : ""}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="border-radiusImportant"
                  {...getTableBodyProps()}
                >
                  {rows.map((row) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                        {row.cells.map((cell: any) => {
                          return (
                            <td
                              onClick={() => {
                                if (readOnly) {
                                  if (cell?.column?.id?.toLowerCase() === "edit") {
                                    redirectTo(cell?.row?.original?.id, "edit")
                                  }
                                }
                                else {
                                  if (
                                    cell?.column?.id?.toLowerCase() === "delete"
                                  ) {
                                    console.log("inside delete");
                                    toggleDisplayToast({
                                      // @ts-ignore
                                      text: `Are you sure you want to delete the Service?`,
                                      type: "warning",
                                      onClickText: "Yes",
                                      // @ts-ignore
                                      patient: cell?.row?.original?.id,
                                    })
                                  }
                                  if (cell?.column?.id?.toLowerCase() === "edit") {
                                    redirectTo(cell?.row?.original?.id, "edit")
                                  }
                                }
                              }}
                              style={{
                                maxWidth: "300px",
                                width: "300px",
                                wordWrap: "break-word",
                                maxHeight: "100px",
                                paddingLeft: "40px",
                                verticalAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "18px",
                                lineHeight: "24px",
                                letterSpacing: "1.35px",
                                textAlign: "initial",
                                textTransform: "capitalize",
                              }}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  {footerGroups.map((footerGroup) => (
                    <tr {...footerGroup.getFooterGroupProps()}>
                      {footerGroup.headers.map((column) => (
                        <td {...column.getFooterProps()}>
                          {column.render("Footer")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      {displayToast && (
        <Toast
          // @ts-ignore
          textMessage={displayToast?.text}
          // @ts-ignore
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={
            // @ts-ignore
            displayToast?.onClickText ? displayToast?.onClickText : null
          }
          onClick={() =>
            // @ts-ignore
            displayToast?.patient
              ? // @ts-ignore
              handleDelete(displayToast?.patient)
              : null
          }
          // @ts-ignore
          type={displayToast?.type}
        />
      )}
    </div>
  )
}
